module.exports = __webpack_public_path__ + "img/parcel-undeliverable.ccb1a990.svg";